import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HrBaseElementComponent } from '../hr-base-element/hr-base-element.component';

@Component({
    selector: 'hr-form-calendar',
    templateUrl: './hr-form-calendar.component.html',
})
export class HrFormCalendarComponent extends HrBaseElementComponent {
    @Input() dateFormat: string = 'dd.mm.yy';
    @Input() minDate?: Date;
    @Input() maxDate?: Date;
    @Output() onSelect? = new EventEmitter<Date>();

    public onDateSelected(date: Date) {
        this.onSelect?.emit(date);
    }
}
